/**
 * Cart Upsell Carousel
 * - Variant select: updates hidden input + displayed price
 * - Add-to-cart animation: triggers the checkmark burst on submit
 * - Prevents slideshow drag from blocking interactive elements (select, button)
 * Carousel behaviour is handled by the theme's native slideshow-component.
 */

/*
 * Prevent the slideshow's drag handler from blocking interactive elements.
 *
 * The slideshow registers a bubble-phase mousedown on <slideshow-slides> that
 * calls event.preventDefault(), blocking native <select> dropdowns, and then
 * enters drag mode which applies pointer-events: none to all children.
 *
 * Strategy: a capture-phase listener at document level adds a one-time
 * bubble-phase handler on the upsell card. The mousedown propagates normally
 * down to the <select> (opening the native dropdown), then on the way back up
 * the card handler stops propagation before it reaches <slideshow-slides>.
 */
document.addEventListener(
  'mousedown',
  (e) => {
    if (!(e.target instanceof Element)) return;
    const card = e.target.closest('.mp-cart-upsell__card');
    if (!card) return;
    if (!e.target.closest('select, button, a')) return;

    // One-time bubble handler: stops the event before <slideshow-slides>
    card.addEventListener(
      'mousedown',
      (bubbleE) => bubbleE.stopPropagation(),
      { once: true }
    );
  },
  true
);

/* Variant select */
document.addEventListener('change', (e) => {
  const select = e.target.closest('[data-upsell-variant-select]');
  if (!select) return;

  const card = select.closest('.mp-cart-upsell__card');
  if (!card) return;

  const selectedOption = select.options[select.selectedIndex];
  const variantInput = card.querySelector('input[name="id"]');
  const priceDisplay = card.querySelector('[data-upsell-price-display]');

  if (variantInput) {
    variantInput.value = select.value;
  }

  if (priceDisplay && selectedOption) {
    priceDisplay.textContent = selectedOption.dataset.price;
  }
});

/* Add-to-cart animation on submit */
document.addEventListener('submit', (e) => {
  const card = e.target.closest('.mp-cart-upsell__card');
  if (!card) return;

  const btn = card.querySelector('.mp-cart-upsell__add-btn');
  if (!btn || btn.dataset.added === 'true') return;

  btn.dataset.added = 'true';
});
